import API_PUBLIC_SERVICE from './http';

const PREFIX = 'insurances';

const path = PREFIX;

const pagePath = '/insurance';
const pagesRoute = {
  editPage: val => `${pagePath}/edit/${val}/`,
  addPage: () => `${pagePath}/add/`,
  listPage: () => `${pagePath}/list/`
};
const tableData = {
  tableName: '',
  tableHeader: [
    {
      id: 'code',
      key: 'code',
      disablePadding: false,
      numeric: false,
      label: 'Código'
    },
    {
      id: 'name',
      key: 'name',
      disablePadding: false,
      numeric: false,
      label: 'Nombre'
    },
    {
      id: '_id',
      key: '_id',
      disablePadding: false,
      numeric: false,
      label: 'Acciones',
      style: {
        width: '130px'
      },
      actions: pagesRoute
    }
  ],
  getKeyTable: () => '_id',
  makeDataTable: value => value,
  hasAddOption: true,
  hasCheckbox: false,
  isAdvancedDateFilter: false,
  ...pagesRoute
};

const InsuranceService = {
  ...API_PUBLIC_SERVICE,
  ...tableData,
  path
};

export default InsuranceService;
